import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

export interface Contact {
  id: number;
  firstName: string;
  lastName?: string;
  email: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  totalPages: number;
  totalContacts: number;
}

export interface Response {
  data: Contact[];
  meta: PaginationMeta;
}

export const fetchAll = async (
  page: number,
  limit: number
): Promise<Response> => {
  const response = await axios.get(
    `${process.env.REACT_APP_CONTACTS_SVC_URL}/contacts?page=${page}&limit=${limit}`
  );
  return response.data;
};
